import React from 'react';

const ListingSkeleton: React.FC = () => {
    return (
        <div className="relative aspect-[3/4] w-full rounded-[2.5rem] overflow-hidden bg-gray-100 dark:bg-gray-900 border border-gray-200/10 dark:border-white/5 shadow-xl">
            {/* Shimmer Base */}
            <div className="absolute inset-0 shimmer-effect opacity-30 dark:opacity-20" />

            {/* Price Chip Placeholder (Top Left) */}
            <div className="absolute top-5 left-5 z-10">
                <div className="h-10 w-24 bg-white/20 dark:bg-white/10 backdrop-blur-xl rounded-2xl animate-pulse" />
            </div>

            {/* Favorite Placeholder (Top Right) */}
            <div className="absolute top-5 right-5 z-10">
                <div className="w-10 h-10 bg-white/20 dark:bg-white/10 backdrop-blur-xl rounded-full animate-pulse" />
            </div>

            {/* Content Section (Bottom Overlaid) */}
            <div className="absolute inset-x-0 bottom-0 p-6 pt-12 bg-gradient-to-t from-gray-200/90 dark:from-black/95 via-gray-100/40 dark:via-black/40 to-transparent">
                <div className="space-y-3">
                    {/* Badge Placeholder */}
                    <div className="h-4 w-16 bg-gray-300 dark:bg-gray-800 rounded-full animate-pulse" />

                    {/* Title Placeholder */}
                    <div className="space-y-1.5">
                        <div className="h-5 w-full bg-gray-400/30 dark:bg-white/10 rounded-lg animate-pulse" />
                        <div className="h-5 w-2/3 bg-gray-400/30 dark:bg-white/10 rounded-lg animate-pulse" />
                    </div>

                    {/* Metadata Placeholder */}
                    <div className="flex justify-between items-center pt-2">
                        <div className="h-3 w-20 bg-gray-300/40 dark:bg-gray-800 rounded animate-pulse" />
                        <div className="h-3 w-12 bg-gray-300/40 dark:bg-gray-800 rounded animate-pulse" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListingSkeleton;

